import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=7c1c11ac&scoped=true&"
import script from "./ItemImage.vue?vue&type=script&lang=js&"
export * from "./ItemImage.vue?vue&type=script&lang=js&"
import style0 from "./ItemImage.vue?vue&type=style&index=0&id=7c1c11ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c11ac",
  null
  
)

export default component.exports